import React, { useEffect, useRef, useState } from "react";

const QuantitystepperCart = (props) => {
    const [quantity, setQuantity] = useState(props.quantity);
    const [inStockQuantity, setInStockQuantity] = useState(props.inStockQuantity);
    const timeoutRef = useRef(0);

    useEffect(() => {
        setQuantity(props.quantity);
    }, [props.quantity]);

    const incrementItem = (event) => {
        event.preventDefault();
        let newQuantity = quantity + 1;
        if (newQuantity <= parseInt(inStockQuantity)) {
            setQuantity(newQuantity);

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                props.onQuantityChange(newQuantity, props.index);
            }, 500);
        }
    };

    const decreaseItem = (event) => {
        event.preventDefault();
        let newQuantity = Math.max(quantity - 1, 0);

        setQuantity(newQuantity);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            props.onQuantityChange(newQuantity, props.index);
        }, 500);
    };

    const handleChange = (event) => {
        const value = parseInt(event.target.value);
        let maxQty = parseInt(inStockQuantity)
        if (!isNaN(value)) {
            let newQuantity = Math.max(value, 0);
            if (newQuantity > maxQty) {
                newQuantity = maxQty
            }

            props.onQuantityChange(newQuantity, props.index);
        }
    };

    return (
        <div className="quantity-selector">
            <a className="quantity-selector__minus" onClick={decreaseItem}>
                <svg className="icon">
                    <use href="/UI/images/sprites/habo-sprite.svg#minus"></use>
                </svg>
            </a>
            <input
                id={props.modelid}
                type="text"
                data-buy-quantity-input
                initialvalue={quantity}
                value={quantity}
                onChange={handleChange}
                min="1"
                max="999"
                maxLength="3"
            />
            <a className="quantity-selector__plus" onClick={incrementItem}>
                <svg className="icon">
                    <use href="/UI/images/sprites/habo-sprite.svg#plus"></use>
                </svg>
            </a>
        </div>
    );
}

export default QuantitystepperCart;
